import { CancelToken } from "axios";
import {
  WoltDeliveryPromiseDependantData,
  WoltDeliveryPromise,
} from "@/types";
import {DeliveryApi} from "@/api/delivery.api";

export class WoltDeliveryApi extends DeliveryApi {

  getAddresses(
    query: string,
    language: string,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    return this.axios
      .get<{ predictions: Array<{ description: string }> }>(
        `/api/address/woltAutocomplete`,
        {
          params: {
            input: query,
            language,
            types: "geocode",
            components: `country:${window.mangasPortal}`,
          },
          cancelToken,
        }
      )
      .then((r) => r.data.predictions.map((p) => p.description));
  }

  calculateDelivery(
    saleId: number,
    data: WoltDeliveryPromiseDependantData,
    cancelToken?: CancelToken
  ): Promise<WoltDeliveryPromise> {
    return this.axios
      .post<{ promise: WoltDeliveryPromise }>(
        "/delivery/promise",
        { saleId, ...data },
        { cancelToken }
      )
      .then((r) => r.data.promise);
  }
}
